import { render, staticRenderFns } from "./AttachmentBadge.vue?vue&type=template&id=255ac5e7"
import script from "./AttachmentBadge.vue?vue&type=script&lang=js"
export * from "./AttachmentBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports